document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.concern-tab-button');
  const tabContents = document.querySelectorAll('.concern-tab-content');

  function updateVisibleDots(flkty) {
  const dots = flkty.pageDots?.dots;

  if (!dots || dots.length <= 5) return;

  const selectedIndex = flkty.selectedIndex;

  let start = Math.max(0, selectedIndex - 2);
  let end = start + 5;

  if (end > dots.length) {
    end = dots.length;
    start = end - 5;
  }

  dots.forEach((dot, index) => {
    dot.style.display =
      index >= start && index < end
        ? 'inline-block'
        : 'none';
  });
}

  if (tabButtons.length > 0) {
    tabButtons[0].classList.add('active');
    tabButtons[0].style.background = tabButtons[0].getAttribute('data-color');
    tabButtons[0].style.border = tabButtons[0].getAttribute('data-color');
    tabButtons[0].href = tabButtons[0].getAttribute('data-collection-url');

    tabContents[0].classList.add('active');

    const activeCollectionLink = document.querySelector('.home-view-all-btn');
    if (activeCollectionLink) {
      activeCollectionLink.href = `${tabButtons[0].href}`;
    }
  }

  const firstActiveCarousel = document.querySelector('.concern-tab-content.active .carousel');
  if (firstActiveCarousel) {
    const flkty = new Flickity(firstActiveCarousel, {
      fullscreen: false,
      adaptiveHeight: true,
      lazyLoad: true,
      freeScroll: false,      
      contain: true,
      wrapAround: false,
      pageDots: true
    });
    updateVisibleDots(flkty);
    flkty.on('change', function () {
      updateVisibleDots(flkty);
    });
    flkty.select(0, false, true);
  }

  tabButtons.forEach((button) => {
    button.addEventListener('click', function () {
      let tabId = this.getAttribute('data-tab');

      tabButtons.forEach((btn) => {
        btn.classList.remove('active');
        btn.style.background = '#000';
        btn.style.border = '0.5px solid #000';
      });

      tabContents.forEach((content) => {
        content.classList.remove('active');
      });

      this.classList.add('active');
      this.style.background = this.getAttribute('data-color');
      this.style.border = this.getAttribute('data-color');

      document.getElementById(tabId).classList.add('active');

      const collectionUrl = this.getAttribute('data-collection-url');
      if (collectionUrl) {
        const activeCollectionLink = document.querySelector('.home-view-all-btn');
        if (activeCollectionLink) {
          activeCollectionLink.href = `${collectionUrl}`;
        }
      }

      const newActiveCarousel = document.querySelector(`#${tabId} .carousel`);
      if (newActiveCarousel) {
        const flktyInstance = Flickity.data(newActiveCarousel);
        if (flktyInstance) {
          flktyInstance.destroy();
          newActiveCarousel.style.transform = 'none';
        }

        const newFlkty = new Flickity(newActiveCarousel, {
          fullscreen: false,
          adaptiveHeight: true,
          lazyLoad: true,
          freeScroll: false,     
          contain: true,
          wrapAround: false,
          pageDots: true
        });
        updateVisibleDots(newFlkty);
        newFlkty.on('change', function () {
          updateVisibleDots(newFlkty);
        });
        newFlkty.select(0, false, true);
      }
    });
  });
});